<script lang="ts">
  import { t } from '$core/i18n';
  import { listConjectures, createConjecture, deleteConjecture } from '$db/local/repositories';
  import { liveSync } from '$db/local/live.svelte';
  import type { Conjecture } from '$domain/types';
  import { Button } from '$ui/primitives/Button';
  import { Icon } from '$ui/primitives/Icon';
  import { EmptyState } from '$ui/primitives/EmptyState';
  import { Textarea } from '$ui/primitives/Textarea';

  let conjectures = $state<Conjecture[]>([]);
  let contentDraft = $state('');

  liveSync(
    () => listConjectures(),
    (v) => { conjectures = v; }
  );

  async function save() {
    if (!contentDraft.trim()) return;
    // Usamos un nodeId de prueba o el primero que haya, ya que no hay selector aquí
    await createConjecture({ nodeId: 'global', content: contentDraft.trim() });
    contentDraft = '';
  }
</script>

<section class="view">
  <header class="view-head">
    <h1 class="view-title">{t('conjectures.title')}</h1>
  </header>

  <div class="input-area">
    <Textarea placeholder="Write a new conjecture..." bind:value={contentDraft} />
    <Button variant="filled" onclick={save}>Save</Button>
  </div>

  {#if conjectures.length === 0}
    <EmptyState icon="lightbulb" title="No conjectures" description="Start by adding one." />
  {:else}
    <div class="list">
      {#each conjectures as c (c.id)}
        <div class="card">
          <p>{c.content}</p>
          <div class="meta">
            <span>{c.createdAt.slice(0, 10)}</span>
            <button onclick={() => deleteConjecture(c.id)}><Icon name="trash" size={14} /></button>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</section>

<style>
  .view { display: flex; flex-direction: column; gap: var(--space-4); }
  .input-area { display: flex; gap: var(--space-2); align-items: flex-start; }
  .input-area :global(textarea) { flex: 1; }
  .list { display: flex; flex-direction: column; gap: var(--space-2); }
  .card { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-md); padding: var(--space-4); }
  .meta { display: flex; justify-content: space-between; margin-top: var(--space-2); font-size: var(--text-xs); color: var(--color-text-muted); }
  .meta button { background: transparent; border: none; color: var(--color-danger); cursor: pointer; }
</style>